var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 674 676",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-9150,-4516)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2265.1,-16.3815)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2265.1,16.3815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9647.58,5167.3L9646.94,5167.97L9200.85,5167.97C9186.49,5167.97 9174.85,5156.32 9174.85,5141.97L9174.85,4566.69C9174.85,4552.33 9186.49,4540.69 9200.85,4540.69L9773.98,4540.69C9788.34,4540.69 9799.98,4552.33 9799.98,4566.69L9799.98,5009.26L9799.11,5010.16L9799.84,5010.86C9799.85,5010.86 9799.85,5010.88 9799.85,5010.89C9799.85,5010.9 9799.85,5010.92 9799.84,5010.93L9648.1,5167.72C9648.08,5167.74 9648.05,5167.74 9648.03,5167.72L9647.58,5167.3Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(49,57,65)",
      strokeWidth: 48
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2265.1,16.3815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9266.88,4676.7L9674.07,4676.7",
    style: {
      fill: "none",
      stroke: "rgb(49,57,65)",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2265.1,134.849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9266.88,4676.7L9674.07,4676.7",
    style: {
      fill: "none",
      stroke: "rgb(49,57,65)",
      strokeWidth: 48,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.729515,0,0,1,241.458,257.17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9266.88,4676.7L9674.07,4676.7",
    style: {
      fill: "none",
      stroke: "rgb(49,57,65)",
      strokeWidth: "54.84px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.62eeb89c68e352b38ff675e1182df0d4.svg";
export { ForwardRef as ReactComponent };